import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

/**
 * Fetches the distinct buyers previously used across an org's simulations, for the onboarding
 * wizard's "reuse a previous buyer" picker. Each entry is
 * `{ companyWebsite, companyLinkedInUrl, buyerCompanyName, buyerContacts, lastUsedOn, simulationCount }`.
 */
const getPreviousBuyers = (organizationId, callback, errorCallback) => {
  return async (dispatch) => {
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const reqId = uuidv4();
        try {
          const response = await axios.get(
            '/ads/admin/simulations/previous-buyers',
            {
              params: {
                organizationId,
                'request-id': reqId,
              },
              headers: {
                Authorization: `Bearer ${token}`,
              },
            },
          );
          if (response.status === 200) {
            if (typeof callback === 'function')
              callback(response?.data?.buyers || []);
          } else {
            if (typeof errorCallback === 'function')
              errorCallback('Failed to fetch previous buyers');
          }
        } catch (e) {
          if (typeof errorCallback === 'function')
            errorCallback(
              e?.response?.data?.message || 'Failed to fetch previous buyers',
            );
        }
        unsubscribe();
      });
    } catch (e) {
      if (typeof errorCallback === 'function')
        errorCallback('Failed to fetch previous buyers');
    }
  };
};

export default getPreviousBuyers;
